import SaltCrystal from "../V2/Icons/SaltCrystal";
import Clock from "../Icons/V2/Clock";
import { motion } from "framer-motion";

const ProgressBar = ({
	percentage,
	remainingTime,
}: {
	percentage: number;
	remainingTime: string;
}) => {
	return (
		<>
			<div className="progress-bar-wrapper">
				<div className="flex color-abyssal-blue-400 justify-content-space-between mb-2">
					<div>
						<div className="fs-12 fw-500 font-tertiary">Your progress</div>
						<div className="fs-16 fw-500 font-secondary">
							{percentage}% completed
						</div>
					</div>
					<div className="fs-12 fw-500 font-tertiary flex align-items-start gap-x-2">
						<Clock color="var(--abyssal-blue-400)" size={14} />
						{remainingTime}
					</div>
				</div>
				<div className="progress-bar">
					<motion.div
						layout
						transition={{
							type: "spring",
							stiffness: 70,
						}}
						style={{
							position: `absolute`,
							left: 0,
							height: `12px`,
							borderRadius: `var(--sp-03)`,
							width: `${percentage}%`,
							background: `var(--lavender-400)`,
						}}
					></motion.div>
					<motion.div
						layout
						transition={{
							type: "spring",
							stiffness: 70,
						}}
						style={{
							height: `24px`,
							width: `24px`,
							borderRadius: `50%`,
							background: `var(--primary-500)`,
							position: `absolute`,
							display: `flex`,
							alignItems: `center`,
							justifyContent: `center`,
							top: `-6px`,
							left: `calc(${percentage}% - 8px)`,
						}}
					>
						<SaltCrystal color="#FFF" />
					</motion.div>
				</div>
			</div>

			<style jsx>{`
				.progress-bar-wrapper {
					border-radius: 16px 16px 0px 0px;
					box-shadow: 0px -4px 8px 0px rgba(0, 0, 0, 0.08);
					padding: var(--sp-02) var(--sp-03);
					background: #fff;
				}
				.progress-bar {
					position: relative;
					width: 100%;
					height: 12px;
					background: var(--abyssal-blue-50);
					border-radius: var(--spx-05);
				}
			`}</style>
		</>
	);
};

export default ProgressBar;
